import { getProfile, getGroups } from "@/services/user/user.service";

import {
  STORAGE_ID_TOKEN,
  STORAGE_ACCESS_TOKEN,
  STORAGE_PROFILE,
  STORAGE_EXPIRES_AT,
  STORAGE_USER_GROUPS,
  STORAGE_FEEDBACK_LOOP,
} from "@/common/constants/storage";
export { _getIdToken as getIdToken };
export { _getAccessToken as getAccessToken };
export { _getUserProfile as getUserProfile };
export { _getUserFeedbackLoop as getUserFeedbackLoop };
export { _clearIdToken as clearIdToken };
export { _clearAccessToken as clearAccessToken };
export { _clearUserProfile as clearUserProfile };
export { _clearUserFeedbackLoop as clearUserFeedbackLoop };
export { _clearExpiresAt as clearExpiresAt };
export { _clearAllStorage as clearAllStorage };
export { _setAccessToken as setAccessToken };
export { _setIdToken as setIdToken };
export { _getAndSetUserProfile as getAndSetUserProfile };
export { _setUserProfile as setUserProfile };
export { _setUserFeedbackLoop as setUserFeedbackLoop };
export { _setUserGroups as setUserGroups };
export { _getUserGroups as getUserGroups };
export { _getOrganizationGroup as getOrganizationGroup };

const _getIdToken = () => {
  const ID_TOKEN = localStorage.getItem(STORAGE_ID_TOKEN);
  if (!ID_TOKEN || ID_TOKEN === "null") {
    return null;
  }
  return ID_TOKEN;
};

const _getAccessToken = () => {
  const ACCESS_TOKEN = localStorage.getItem(STORAGE_ACCESS_TOKEN);
  if (!ACCESS_TOKEN || ACCESS_TOKEN === "null") {
    return null;
  }
  return ACCESS_TOKEN;
};

const _getUserProfile = () => {
  const profile = localStorage.getItem(STORAGE_PROFILE);
  return profile && profile !== "undefined" ? JSON.parse(profile) : null;
};

const _getUserFeedbackLoop = () => {
  const FEEDBACK = localStorage.getItem(STORAGE_FEEDBACK_LOOP);
  if (!FEEDBACK || FEEDBACK === "null") {
    return null;
  }
  return JSON.parse(FEEDBACK);
};

const _clearIdToken = () => {
  localStorage.removeItem(STORAGE_ID_TOKEN);
};

const _clearAccessToken = () => {
  localStorage.removeItem(STORAGE_ACCESS_TOKEN);
};

const _clearUserProfile = () => {
  localStorage.removeItem(STORAGE_PROFILE);
};

const _clearUserFeedbackLoop = () => {
  localStorage.removeItem(STORAGE_FEEDBACK_LOOP);
};

const _clearExpiresAt = () => {
  localStorage.removeItem(STORAGE_EXPIRES_AT);
};

const _clearAllStorage = () => {
  _clearIdToken();
  _clearAccessToken();
  _clearUserProfile();
  _clearExpiresAt();
  _clearUserFeedbackLoop();
};

// Store access_token in local storage
const _setAccessToken = (accessToken) => {
  accessToken = !accessToken || accessToken === "null" ? null : accessToken;
  if (accessToken) {
    localStorage.setItem(STORAGE_ACCESS_TOKEN, accessToken);
  }
};

// Store id_token in local storage
const _setIdToken = (idToken) => {
  idToken = !idToken || idToken === "null" ? null : idToken;
  if (idToken) {
    localStorage.setItem(STORAGE_ID_TOKEN, idToken);
  }
};

// Get and store id_token in session storage
const _getAndSetUserProfile = async () => {
  try {
    const RESULT = await getProfile();
    if (RESULT === 401) {
      return RESULT;
    }

    const { data } = JSON.parse(RESULT);
    if (data && data.user_profile) {
      const PROFILE = JSON.stringify(data.user_profile);
      _setUserProfile(PROFILE);
      return true;
    } else {
      console.error(
        "Unable to set user profile storage, data.user_profile not available."
      );
      return false;
    }
  } catch (error) {
    console.error("Unable to set user profile storage", error);
    return false;
  }
};

const _setUserProfile = (profile) => {
  localStorage.setItem(STORAGE_PROFILE, profile);
};

const _setUserFeedbackLoop = (feedback) => {
  localStorage.setItem(STORAGE_FEEDBACK_LOOP, JSON.stringify(feedback));
};

// Helper function that will allow us to extract the access_token and id_token
const _getParameterByName = (name) => {
  let match = RegExp("[#&]" + name + "=([^&]*)").exec(window.location.hash);
  return match && decodeURIComponent(match[1].replace(/\+/g, " "));
};

/**
 * @overview Store user groups in local storage
 */
const _setUserGroups = async () => {
  const groups = await getGroups();
  localStorage.setItem(STORAGE_USER_GROUPS, JSON.stringify(groups));
};

/**
 * @overview Get user groups from local storage
 */
const _getUserGroups = () => {
  return JSON.parse(localStorage.getItem(STORAGE_USER_GROUPS));
};

/**
 * @overview Get user_ group from local storage
 */
const _getOrganizationGroup = () => {
  let groups = _getUserGroups();
  if (groups && Array.isArray(groups) && groups.length) {
    for (let i = 0; i < groups.length; i++) {
      if (
        groups[i].name &&
        groups[i].name.toLowerCase().indexOf("user_") === 0
      ) {
        return groups[i];
      }
    }
  }
};
